export class ViewModelFiltraProcessoInstitutosLegais {
    dtInicio: string;
    dtFim: string;
    idPlano: number;
    nrCpf: string;
}